// @core/api/endpoints/context/get_context_layout.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetContextLayoutResponse,
} from '../../../types/context';

const BASE_PATH = '/context';

/**
 * Get Context Panel layout for an entity
 * Computes the optimal Context Panel layout by evaluating aspect and relation manifests against the entity's status, user role, urgency signals, and user preferences. Returns ordered sections with display modes.
 */
export async function GetContextLayout(
  entity_type: string,
  entity_id: string,
  options?: RequestOptions
): Promise<GetContextLayoutResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/context/layout/:entity_type/:entity_id`;
  requestPath = requestPath.replace(':entity_type', encodeURIComponent(entity_type));
  requestPath = requestPath.replace(':entity_id', encodeURIComponent(entity_id));
  const requestOptions = options;
  return client.get<GetContextLayoutResponse>(requestPath, { ...requestOptions });
}
